<div class="page">

  <!-- ============================ Top bar ============================ -->
  <header class="topbar">
    <div class="topbar-in">
      <span class="brand"><img class="brand-logo-img" src="iflyfinance-logo.png" alt="iFlyFinance" /></span>
      <span class="topbar-pill">Aviation premium finance</span>
      <a routerLink="/login" class="topbar-login">Producer login</a>
    </div>
  </header>

  <main class="wrap">

    <!-- ============================ Hero ============================ -->
    <section class="hero">
      <div class="hero-copy">
        <p class="eyebrow">Premium finance · Aviation · Broker &amp; BWI</p>
        <h1 class="hero-title">Pay for your aircraft insurance monthly.</h1>
        <p class="hero-sub">
          Flexible aviation insurance financing with competitive rates and a simple, guided process
          through your broker or BWI Aviation Insurance.
        </p>
        <div class="hero-actions">
          <button mat-raised-button color="primary" class="hero-cta" routerLink="/login">
            <mat-icon>login</mat-icon>
            Producer Login
          </button>
          <!-- <button mat-stroked-button class="cta-button signup-button" routerLink="/signup">
            <mat-icon>business</mat-icon>
            Sign Up Company
          </button> -->
          <a href="tel:18006663459" class="hero-ghost-wrap">
            <button mat-stroked-button class="hero-ghost">
              <mat-icon>phone</mat-icon>
              Talk to our Team
            </button>
          </a>
        </div>
      </div>

      <!-- Signature: flight-path motif (decorative) -->
      <div class="hero-art" aria-hidden="true">
        <span class="hero-art-eb mono">Takeoff → paid in full</span>
        <div class="path">
          <svg class="path-line" viewBox="0 0 600 128" preserveAspectRatio="none">
            <defs>
              <linearGradient id="homeFlightGrad" x1="0" y1="1" x2="1" y2="0">
                <stop offset="0" class="grad-start"/>
                <stop offset="1" class="grad-end"/>
              </linearGradient>
            </defs>
            <line x1="30" y1="102" x2="570" y2="29" stroke="url(#homeFlightGrad)" stroke-width="2.5" stroke-linecap="round"/>
          </svg>
          <div class="mk takeoff" style="left:5%;bottom:20.3%"><span class="mk-lab mono">Takeoff</span></div>
          <div class="mk" style="left:35%;bottom:39.3%"></div>
          <div class="mk" style="left:65%;bottom:58.3%"></div>
          <div class="mk end" style="left:95%;bottom:77.3%"><span class="mk-lab mono">Paid</span></div>
        </div>
        <div class="hero-art-ends">
          <span><b class="mono">Down payment</b> today</span>
          <span class="mid mono">Monthly · fixed</span>
        </div>
      </div>
    </section>

    <!-- ==================== Main features ==================== -->
    <h2 class="section-label">Aircraft Insurance Financing for You</h2>
    <div class="protos">
      <article class="proto">
        <div class="proto-accent" aria-hidden="true"></div>
        <h3 class="proto-title">Flexible Financing</h3>
        <p class="proto-tagline">Pay over time</p>
        <p class="proto-body">
          Spread your premium into manageable monthly payments so you can protect your aircraft without tying up cash.
        </p>
        <a mat-stroked-button href="mailto:support@iflyfinance.com" class="proto-cta">Get in touch</a>
      </article>

      <article class="proto">
        <div class="proto-accent" aria-hidden="true"></div>
        <h3 class="proto-title">Aviation inspired</h3>
        <p class="proto-tagline">Built for aircraft owners</p>
        <p class="proto-body">
          Competitive rates and terms designed for aviation insurance—not generic consumer financing.
        </p>
        <a mat-stroked-button routerLink="/login" class="proto-cta">Learn more</a>
      </article>

      <article class="proto">
        <div class="proto-accent" aria-hidden="true"></div>
        <h3 class="proto-title">Peace of mind</h3>
        <p class="proto-tagline">Expert support</p>
        <p class="proto-body">
          Dedicated support from aviation insurance experts who understand your coverage and your goals.
        </p>
        <a mat-stroked-button href="tel:18006663459" class="proto-cta">Talk to our team</a>
      </article>
    </div>

    <!-- ==================== Process (flight-path stepper) ==================== -->
    <h2 class="section-label">A Simple Way to Pay for Aviation Insurance</h2>
    <div class="steps-container">
      <div class="step">
        <div class="step-circle mono">1</div>
        <div class="step-content">
          <p>Request financing through your broker or BWI</p>
        </div>
      </div>
      <div class="step-connector" aria-hidden="true"></div>
      <div class="step">
        <div class="step-circle mono">2</div>
        <div class="step-content">
          <p>Review your payment options</p>
        </div>
      </div>
      <div class="step-connector" aria-hidden="true"></div>
      <div class="step">
        <div class="step-circle mono">3</div>
        <div class="step-content">
          <p>Choose a plan that works for you</p>
        </div>
      </div>
    </div>

    <!-- ==================== Second feature set ==================== -->
    <h2 class="section-label">Why Aircraft Owners Use iFlyFinance</h2>
    <div class="features-grid">
      <mat-card class="feature-card" appearance="outlined">
        <mat-card-header class="home-feature-card-header">
          <div mat-card-avatar class="feature-avatar">
            <mat-icon>monetization_on</mat-icon>
          </div>
          <mat-card-title>Preserve Your Cash</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>Avoid large upfront payments and keep your capital available for what matters most</p>
        </mat-card-content>
      </mat-card>

      <mat-card class="feature-card" appearance="outlined">
        <mat-card-header class="home-feature-card-header">
          <div mat-card-avatar class="feature-avatar">
            <mat-icon>event</mat-icon>
          </div>
          <mat-card-title>Flexible Payments</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>Break your premium into predictable monthly payments that fit your budget</p>
        </mat-card-content>
      </mat-card>

      <mat-card class="feature-card" appearance="outlined">
        <mat-card-header class="home-feature-card-header">
          <div mat-card-avatar class="feature-avatar">
            <mat-icon>grade</mat-icon>
          </div>
          <mat-card-title>Expert Support</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>Work with a team that understands aviation insurance and guides you through the process</p>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- ==================== Experts / credibility ==================== -->
    <h2 class="section-label">Built by Aviation Insurance Experts</h2>
    <p class="experts-lead">
      iFlyFinance is powered by BWI Aviation Insurance, a trusted name in aviation insurance serving
      thousands of aircraft owners nationwide.
    </p>
    <div class="experts-container">
      <div class="stat-card">
        <div class="stat-fig mono">10,000+</div>
        <div class="stat-lab">aviation clients served</div>
      </div>
      <div class="stat-card">
        <div class="stat-fig">Decades</div>
        <div class="stat-lab">of aviation experience</div>
      </div>
      <div class="stat-card">
        <div class="stat-fig mono">800+</div>
        <div class="stat-lab">five star reviews</div>
      </div>
    </div>

    <footer class="page-foot">
      iFlyFinance · powered by BWI Aviation Insurance
    </footer>

  </main>
</div>
